/* eslint-disable camelcase */
import dayjs from 'dayjs';

export class StatisticApiConverter {
  convertStatistic = data => {
    const { format } = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 2,
    });
    const { format: formatCount } = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 0,
    });
    return {
      betCount: formatCount(data.bet_count),
      activeUser: formatCount(data.active_users_count),
      newUsers: formatCount(data.new_users_count),
      totalBets: format(data.total_bets),
      totalWin: format(data.total_win),
      totalNetwin: format(data.total_netwin),
      netwinByDates: data.netwin_by_dates.map(t => ({
        date: t.date,
        netwin: t.netwin,
      })),
      totalUserBalance: format(data.total_user_balance),
      totalAgentBalance: format(data.total_agent_balance),
      usersCount: formatCount(data.users_count),
      referrals: formatCount(data.referral_users_count),
      directTotalNetwin: format(data.direct_total_netwin),
      rankedAgents: data.ranked_agents.map((t, i) => ({
        number: i + 1,
        id: t.user_id,
        username: t.username,
        netwin: format(t.netwin),
      })),
      rankedPlayers: data.ranked_players.map((t, i) => ({
        number: i + 1,
        id: t.user_id,
        username: t.username,
        netwin: format(t.netwin),
        bets: format(t.bets_sum),
        wins: format(t.wins_sum),
      })),
    };
  };
}

export default StatisticApiConverter;
